












import { WebhookEventModel } from '@/app/shared/models';
import { refsService } from '@/app/shared/refs.service';
import { Component, Vue } from 'vue-property-decorator';
import DataTableWebhookEvents from '@/app/shared/components/data-tables/webhook-events.vue';
@Component({
  components: {
    DataTableWebhookEvents,
  },
})
export default class PanelWebhookEventComponent extends Vue {
  private data = { webhookEventList: [] };

  private get refs() {
    return refsService;
  }

  private get webhookEventList(): WebhookEventModel[] {
    this.refs.modules.contract.SET_WEBHOOK_EVENT_LIST(
      this.data.webhookEventList
    );
    return this.refs._.cloneDeep(this.data.webhookEventList);
  }
}
